import * as React from 'react';
import { SVGProps } from 'react';

const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 6.286a4.287 4.287 0 0 1-7.518 2.812l-4.004 2.005c.062.29.053.589.053.857 0 .348.01.647-.053.937l4.004 1.965c.786-.862 1.942-1.474 3.232-1.474 2.366 0 4.286 1.92 4.286 4.326A4.287 4.287 0 0 1 17.714 22a4.261 4.261 0 0 1-4.285-4.286c0-.308.03-.607.093-.897l-4.004-2.005a4.276 4.276 0 0 1-3.232 1.474C3.919 16.286 2 14.366 2 11.96a4.286 4.286 0 0 1 4.286-4.286c1.29 0 2.446.612 3.232 1.473l4.004-1.964a4.25 4.25 0 0 1-.093-.897A4.26 4.26 0 0 1 17.714 2 4.286 4.286 0 0 1 22 6.286ZM6.246 14.143c1.223 0 2.142-.96 2.142-2.143 0-1.183-.92-2.143-2.142-2.143-1.144 0-2.143.96-2.143 2.143 0 1.183 1 2.143 2.143 2.143Zm11.468-10a2.143 2.143 0 1 0 .001 4.287 2.143 2.143 0 0 0 0-4.287Zm0 15.714a2.143 2.143 0 1 0 0-4.287 2.143 2.143 0 0 0 0 4.287Z"
      fill="#000"
    />
  </svg>
);

export default SvgShare;
